'use client';

import { MarkdownRenderer } from '@web/ui';

type TermsContentProps = {
  markdownContent: string;
};

export function TermsContent({ markdownContent }: TermsContentProps) {
  return <MarkdownRenderer markdownContent={markdownContent} showLogo />;
}
